module.exports = __webpack_public_path__ + "static/img/cert-brand-3.63a6a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert-brand-3.png
// module id = 9Yv9
// module chunks = 0